import { FaHouseChimney, FaFileInvoiceDollar, FaPeopleGroup, FaChartPie, FaRegChartBar, FaChevronRight, FaChevronDown } from 'react-icons/fa6';
import { IItem } from "../Layout/Sidebar.component";

// Your menu items data structure
const menuItems: IItem[] = [
    {
        title: 'Panel Central',
        icon: <FaHouseChimney />,
        link: '/dashboard',
    },
    {
        title: 'Documentos de pago',
        icon: <FaFileInvoiceDollar />,
        subMenu: [
            {
                title: 'Recibidos',
                icon: <FaFileInvoiceDollar />,
                subMenu: [
                    { title: 'Dashboard', icon: <FaFileInvoiceDollar />, link: '/dashboard-pagos' },
                    { title: 'Facturas', icon: <FaFileInvoiceDollar />, link: '/facturas' },
                    { title: 'Notas de crédito', icon: <FaFileInvoiceDollar />, link: '/notas-credito' },
                    { title: 'Guias de despacho', icon: <FaFileInvoiceDollar />, link: '/guias-despacho' },
                    { title: 'Boletas', icon: <FaFileInvoiceDollar />, link: '/boletas' },
                ],
            },
            {
                title: 'Emitidos',
                icon: <FaFileInvoiceDollar />,
                subMenu: [
                    { title: 'Facturas', icon: <FaFileInvoiceDollar />, link: '/facturas-emitidas' },
                    { title: 'Notas de crédito', icon: <FaFileInvoiceDollar />, link: '/notas-credito-emitidas' },
                    { title: 'Guias de despacho', icon: <FaFileInvoiceDollar />, link: '/guias-despacho-emitidas' },
                    { title: 'Boletas', icon: <FaFileInvoiceDollar />, link: '/boletas-emitidas' },
                ],
            },
            {
                title: 'Ordenes de Compra',
                icon: <FaFileInvoiceDollar />,
                link: '/ordenes-compra',
            },
        ],
    },
    {
        title: 'Hojas de Control',
        icon: <FaRegChartBar />,
        subMenu: [
            { title: 'Dashboard', icon: <FaRegChartBar />, link: '/hojas-control/dashboard' },
            { title: 'Dashboard General', icon: <FaRegChartBar />, link: '/hojas-control/dashboard-general' },
            { title: 'Hojas de Control', icon: <FaRegChartBar />, link: '/hojas-control/detalle' },
        ],
    },
    {
        title: 'Control de Mano de Obra',
        icon: <FaPeopleGroup />,
        subMenu: [
            { title: 'Dashboard', icon: <FaPeopleGroup />, link: '/mano-obra/dahboard' },
            { title: 'Reporte', icon: <FaPeopleGroup />, link: '/mano-obra/reporte' },
        ],
    },
    {
        title: 'Informe Gerencial',
        icon: <FaChartPie />,
        subMenu: [
            { title: 'Valor Ganado', icon: <FaChartPie />, link: '/informe-gerencial' },
            { title: 'Planificación', icon: <FaChartPie />, link: '/planificacion' },
        ],
    },
    {
        title: 'Servicio de Impuestos Internos',
        icon: <FaHouseChimney />,
        link: '/sii',
    },
];

export default menuItems;